<template>

    <div id="home">

        <HomeNavbar :sticky_navbar="scrolled_from_top" v-if="signed_in != true" />

        <NewFeatureBanner :signed-in="signed_in === true" :navbar-height="navbar_height" />

        <HomeBanner />

        <Features />

        <GreenCircles />

        <TryFreeSevenDays />

        <SampleMenu />

        <Pricing />

        <ContactUs />

        <BeautifulMenus />

        <Partners />

        <PartnerTestimonials />

        <AdditionalServices />

        <HomeFooter :signed_in="signed_in" />
            

    </div>




</template>

<script>
import HomeNavbar from '@/components/home/HomeNavbar.vue'
import NewFeatureBanner from '@/components/home/NewFeatureBanner.vue'
import HomeBanner from '@/components/home/HomeBanner.vue'
import Features from '@/components/home/Features.vue'
import GreenCircles from '@/components/home/GreenCircles.vue'
import TryFreeSevenDays from '@/components/home/TryFreeSevenDays.vue'
import SampleMenu from '@/components/home/SampleMenu.vue'
import Pricing from '@/components/home/Pricing.vue'
import ContactUs from '@/components/home/ContactUs.vue'
import BeautifulMenus from '@/components/home/BeautifulMenus.vue'
import Partners from '@/components/home/Partners.vue'
import PartnerTestimonials from '@/components/home/PartnerTestimonials.vue'
import AdditionalServices from '@/components/home/AdditionalServices.vue'
import HomeFooter from '@/components/home/HomeFooter.vue'




export default {
    name: "Home",
    metaInfo: {
        title: "Menulingua | Digital Menus | Ordering System | QR Code Menus",
        titleTemplate: null,
        meta: [
            {
                name: 'description',
                content: "Build your digital menu for your restaurant, golf course or spa. Edit your QR code menu anytime and match your design & branding. Set up in just 1 minute",
                keywords: 'digital menu, qr code menu, restaurant menu, translation, culinary, tourism'
            }
        ],
        htmlAttrs: {
        lang: 'en'
        },
        link: [
            {rel: 'canonical', href: 'https://menulingua.com'}
        ]
    },
    components: {
        NewFeatureBanner,
        HomeNavbar,
        HomeBanner,
        Features,
        GreenCircles,
        TryFreeSevenDays,
        SampleMenu,
        Pricing,
        ContactUs,
        BeautifulMenus,
        Partners,
        PartnerTestimonials,
        AdditionalServices,
        HomeFooter
    },
    data () {
        return {
            show_screen: false,
            scrolled_from_top: false,
            navbar_height: null, // full height of the fixed bar at the top, so the announcement banner starts below it
            signed_in: Boolean
        }
    },
    created() {
        this.getLanguage();
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.measureNavbarHeight);
        this.checkSignedIn();
        this.$nextTick(() => this.measureNavbarHeight());
        this.navbar_timer = setTimeout(() => this.measureNavbarHeight(), 500); // after web fonts settle
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.measureNavbarHeight);
        clearTimeout(this.navbar_timer);
    },
    methods: {
        handleScroll (event) {
            var target = document.querySelector('#home-navbar');
            // signed-in visitors get the app Header instead of #home-navbar
            var navbarHeight = target ? target.offsetHeight : 70
            if (window.scrollY >= navbarHeight + 0) {
                this.scrolled_from_top = true
            } else if (window.scrollY < navbarHeight + 0) {
                this.scrolled_from_top = false
            }
        },
        // Signed out: the free-trial strip (its height varies with the text wrapping) plus the 70px navbar, as
        // it is before scrolling shrinks it. Signed in: the app Header, 75px.
        measureNavbarHeight() {
            if (this.signed_in === true) {
                this.navbar_height = 75
                return
            }
            var strip = document.querySelector('#home-navbar .account-refer')
            this.navbar_height = (strip ? strip.offsetHeight : 0) + 70
        },
        checkSignedIn() {
            if (localStorage.signedIn) {
                this.signed_in = true
            } else {
                this.signed_in = false
            }
        },
        getLanguage() {
            if (localStorage.default_language === undefined) {
                this.$store.commit('setDefaultLanguage', 'en')
                localStorage.setItem('default_language', 'en')
            } else {
                this.$store.commit('setDefaultLanguage', localStorage.default_language)
            }
        }
    }

}





</script>

<style scoped>

#home {
    height: max-content;
    display: flex;
    flex-direction: column;
}

.home-screen {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1000;
    display: flex;
    align-items: stretch;
    background-color: rgba(0, 0, 0, 0.3);
}



</style>